import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDeleteCharts,
	deleteChart,
	deleteChartFail,
	deleteChartSuccess,
	fetchChartListFail,
	fetchChartListSuccess,
	initChartList,
	refreshChartList,
} from './chart.actions';
import { ChartOriginalSliceState } from './chart.state';

export const chartOriginalReducer = createReducer<ChartOriginalSliceState>(
	new ChartOriginalSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initChartList, refreshChartList, (state) => state.setLoading(true)),
	on(fetchChartListSuccess, (state, action) =>
		state.setLoading(false).setChartList(action.chartList)
	),
	on(fetchChartListFail, (state) => state.setLoading(false)),
	on(deleteChart, bulkDeleteCharts, (state) => state.setLoading(true)),
	on(deleteChartSuccess, (state) => state.setDeleteSuccess(true)),
	on(deleteChartFail, (state) =>
		state.setDeleteSuccess(false).setLoading(false)
	)
);
